import type { FaireProductEntity } from "../../entity_types/product";

export const p_newhwqhhd7: FaireProductEntity = {
  token: "p_newhwqhhd7",
  type: "product",
  name: "Golden Hour - Cashmere, Cedarwood Coconut Soy 8oz Candle",
  brandToken: "b_f2njjv4jzw",
  brandName: "Milk Jar Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/fcfa9316a9cdb8bde10367eecabfe7f808fe8d7b8ab69d357d859f9e45394ce9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43c947ad990b8525208583aa06853ae1fd9dd12d1cce0a6e7892d02642056b3b.jpeg",
    "https://cdn.faire.com/fastly/8f3dec813df3a81e40491d37f331519cf191a3d54ee698ca569d6e6448c6a2f0.jpeg",
    "https://cdn.faire.com/fastly/55f8bab60a5569008be426c689c40e16cb9827cbc675b27df1b535a6e8105d3c.jpeg",
    "https://cdn.faire.com/fastly/2bd0b184055fef3853e6970b2be4689bf872406b6adc155ebadd97e45c02981e.jpeg",
    "https://cdn.faire.com/fastly/b35122f9af88b1566ccce265ff3ebd72f0d7d29efb71681e167e7e494c04d2a3.jpeg",
    "https://cdn.faire.com/fastly/737a6f080405db18badc749ff9181f7fb9f178479ad614303fe54cb05a73c449.jpeg",
    "https://cdn.faire.com/fastly/f3be2623dee2dbd6aebe0ce68f62c8d2ba0bb02cb67836ba1568a050addf93fc.jpeg",
    "https://cdn.faire.com/fastly/1c815fd52fa0cd0c26de6050911f064c87d9b114e4a2840d81cf85de6eeba875.jpeg",
    "https://cdn.faire.com/fastly/08083b9cd4d7e4a3bafdce4496657081156f93c9c57638a3668a61ec07ab9ab0.jpeg",
    "https://cdn.faire.com/fastly/356e9a412fc12827af4d367238a080289227b14706263ec545c9ebfe3ca8ebbf.jpeg",
  ],
  priceDollars: 14.32,
  description:
    "Cashmere, Cedarwood & Musk · 8 oz Original Coconut Soy Wax Candle\n\nYou know that moment just before sunset when everything turns gold and you suddenly feel like the star of a story you didn’t know you were in? That’s this candle. Cedar wraps you in an enchanted forest hug, cashmere drapes your shoulders, and the sun flirts with the earth. While you, lucky thing, are the glowing third wheel.\n\n• $1 from every candle sold supports the creation of inclusive and inviting spaces around the world\n• Crackling wooden wick\n• Plant based coconut soy wax\n• Scented with high-quality fragrance oils, free from dibutyl phthalates (DBP) and di(2-ethylhexyl) phthalates (DEHP)\n• Vegan and cruelty-free\n• 40-45 hour burn time with proper wick trimming\n• Hand-poured in sunny Calgary",
  tags: [],
  msrpDollars: 30.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:09.628Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
